// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"951271fc","952":"dd07efa2"}[chunkId] + ".chunk.js";
};